var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 438.578,
    height: 500,
    viewBox: "0 0 438.578 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M388.86,204.44,119.34,48.84a3.44,3.44,0,0,0-3.16-.42h0l-.27.16-2.94,1.7,1.69,2.39V233.94a10.44,10.44,0,0,0,4.72,8.18L388.53,397.54l.38,2.41,3.27-1.89h0a3.31,3.31,0,0,0,1.4-3.06V212.62a10.44,10.44,0,0,0-4.72-8.18Z",
    fill: "#d6d8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M390.3,214.52V396.89c0,3-2.1,4.23-4.72,2.72L116.06,244a10.44,10.44,0,0,1-4.72-8.18V53.46c0-3,2.11-4.24,4.72-2.73L385.58,206.34A10.41,10.41,0,0,1,390.3,214.52Z",
    fill: "#fafbfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M287.46,178.09,121.97,82.54V73l165.49,95.55Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M278.88,185,121.97,94.4V89.63l156.91,90.6Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M260.62,183,121.97,102.94V98.17l138.65,80.06Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M251.81,186.45,121.97,111.49v-4.77l129.84,74.96Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M379.21,302.03,318.4,266.92v-9.54l60.81,35.1Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M376.06,312.07,318.4,278.78v-4.77l57.66,33.29Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M369.35,316.74,318.4,287.32v-4.77l50.95,29.42Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M366.11,323.41,318.4,295.87V291.1l47.71,27.54Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M287.46,229.81,121.97,134.26v-9.54l165.49,95.55Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M278.88,236.72,121.97,146.13v-4.78l156.91,90.6Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    d: "M260.62,234.72,121.97,154.67V149.9l138.65,80.05Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M251.81,238.18,121.97,163.21v-4.77L251.81,233.4Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M287.46,281.54,121.97,185.99v-9.55L287.46,272Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M278.88,288.45l-156.91-90.6v-4.77l156.91,90.59Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M260.62,286.45,121.97,206.39v-4.77l138.65,80.05Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M251.81,289.9,121.97,214.94v-4.78l129.84,74.97Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M287.46,333.26,121.97,237.71v-9.54l165.49,95.55Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M278.89,335.4v2.62l-156.92-90.6V244.8Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M377.32,281.69l-57-32.92a4.55,4.55,0,0,1-1.89-3.61V188.93c0-1.39.85-2,1.89-1.43l57,32.92a4.55,4.55,0,0,1,1.89,3.61v56.23C379.21,281.65,378.36,282.29,377.32,281.69Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M388.86,156.17,119.34.56a3.11,3.11,0,0,0-3-.31h-.06l-3,1.68,1.32,2.14V33.64c0,3.47,2.12,7.51,4.73,9l268.95,155.3.14,2.52,3.41-1.88.08-.05.1-.05h0c1-.59,1.57-1.91,1.57-3.77V165.2C393.58,161.72,391.46,157.68,388.86,156.17Z",
    fill: "#d6d8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M385.58,200.09,116.06,44.48c-2.61-1.51-4.72-5.55-4.72-9V6c0-3.47,2.11-5.07,4.72-3.57L385.58,158c2.61,1.51,4.73,5.55,4.73,9v29.51C390.31,200,388.19,201.59,385.58,200.09Z",
    fill: "#fafbfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M377.32,182.09,123.86,35.76A4.52,4.52,0,0,1,122,32.15V21.55c0-1.39.84-2,1.89-1.43L377.32,166.46a4.53,4.53,0,0,1,1.89,3.61v10.59C379.21,182.06,378.36,182.7,377.32,182.09Z",
    fill: "#e9eaf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M377.79,182.37,361.4,172.9V157.27l16.39,9.46a4.53,4.53,0,0,1,1.89,3.61v10.6C379.68,182.33,378.83,183,377.79,182.37Z",
    fill: "#65be7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M130.47,31.53A8,8,0,0,1,129,29.9a2.83,2.83,0,0,1-.44-1.44q0-.8.54-1a1.71,1.71,0,0,1,1.43.3,4.35,4.35,0,0,1,1.79,2,2.94,2.94,0,0,1,.26,1.18l-.77-.45a2.19,2.19,0,0,0-.33-1.15,2.63,2.63,0,0,0-.95-.89,1.16,1.16,0,0,0-.88-.23c-.21.07-.32.28-.32.62a1.57,1.57,0,0,0,.3.87,5.75,5.75,0,0,0,1,1.11A10.72,10.72,0,0,1,131.82,32a4.29,4.29,0,0,1,.61,1,2.65,2.65,0,0,1,.19,1c0,.54-.18.87-.55,1a2,2,0,0,1-1.47-.36,5,5,0,0,1-1.12-.91,4.69,4.69,0,0,1-.8-1.19,3,3,0,0,1-.28-1.21l.77.45a2.08,2.08,0,0,0,.39,1.18,3.21,3.21,0,0,0,1,1,1.34,1.34,0,0,0,.93.25c.22-.07.32-.27.32-.6a1.63,1.63,0,0,0-.3-.93,6.87,6.87,0,0,0-1.04-1.15Z",
    fill: "#b0b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M135.28,37.39a3.88,3.88,0,0,1-1.43-1.49,4.3,4.3,0,0,1-.55-2.1v-.15a2.39,2.39,0,0,1,.25-1.19.94.94,0,0,1,.68-.51,1.41,1.41,0,0,1,1,.22,3.32,3.32,0,0,1,1.31,1.39,4.59,4.59,0,0,1,.47,2.11V36L134,34.33a3.15,3.15,0,0,0,.37,1.41,2.41,2.41,0,0,0,.91,1,1.14,1.14,0,0,0,.66.2.79.79,0,0,0,.48-.22l.45.67C136.55,37.8,136,37.81,135.28,37.39Zm-.09-4.52a.69.69,0,0,0-.75-.06,1.07,1.07,0,0,0-.37.84l2.16,1.25v-.07a2.65,2.65,0,0,0-.31-1.18,1.9,1.9,0,0,0-.73-.78Z",
    fill: "#b0b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M140.49,40.3a2.37,2.37,0,0,1-.11-.58,1.16,1.16,0,0,1-1.23-.09,3,3,0,0,1-1-1,2.33,2.33,0,0,1-.41-1.29c0-.52.17-.82.51-.91a2.07,2.07,0,0,1,1.44.4l.72.41v-.39a1.66,1.66,0,0,0-.23-.84,1.8,1.8,0,0,0-.68-.66.91.91,0,0,0-.67-.15.37.37,0,0,0-.26.4l-.75-.43a.79.79,0,0,1,.23-.59.81.81,0,0,1,.63-.19,2.07,2.07,0,0,1,.86.3,3.18,3.18,0,0,1,1.17,1.1,2.79,2.79,0,0,1,.44,1.44v2.3a4.079,4.079,0,0,0,.15,1.18v.07ZM139.26,39a1.13,1.13,0,0,0,.66.17.53.53,0,0,0,.45-.28v-1l-.58-.34c-.9-.52-1.35-.47-1.35.14a1.35,1.35,0,0,0,.23.76,1.69,1.69,0,0,0,.59.55Z",
    fill: "#b0b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M144.35,38.32a3.273,3.273,0,0,0-.36-.25q-.72-.42-1,.15v3.54l-.73-.43v-5l.71.41v.58c.24-.3.58-.33,1-.07a1.27,1.27,0,0,1,.32.25Z",
    fill: "#b0b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M146.69,43.28a.82.82,0,0,0,.69.12.52.52,0,0,0,.33-.5l.69.4a1,1,0,0,1-.25.67.87.87,0,0,1-.63.26,1.65,1.65,0,0,1-.83-.25,3.6,3.6,0,0,1-1.4-1.49,4.54,4.54,0,0,1-.53-2.16v-.15A2.41,2.41,0,0,1,145,39a.85.85,0,0,1,.66-.49,1.6,1.6,0,0,1,1,.27,3.39,3.39,0,0,1,1.21,1.2,3.27,3.27,0,0,1,.51,1.6l-.69-.4a2.31,2.31,0,0,0-.32-1,2.13,2.13,0,0,0-.71-.72q-.56-.31-.87,0a1.64,1.64,0,0,0-.31,1.17v.16a3.54,3.54,0,0,0,.31,1.51,2.19,2.19,0,0,0,.9.98Z",
    fill: "#b0b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M150,41.4a1,1,0,0,1,1.28,0,2.79,2.79,0,0,1,1.35,2.6v3.3l-.74-.43v-3.3a1.87,1.87,0,0,0-.21-.92A1.81,1.81,0,0,0,151,42a.93.93,0,0,0-.63-.14.64.64,0,0,0-.43.34v3.55l-.74-.43V38.28l.74.42Z",
    fill: "#b0b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M153.75,47.52a.36.36,0,0,1,.12-.31c.07-.05.19,0,.34,0a1,1,0,0,1,.34.35.88.88,0,0,1,.12.44.3.3,0,0,1-.12.28c-.08.05-.19,0-.34,0a.85.85,0,0,1-.34-.34.84.84,0,0,1-.12-.42Z",
    fill: "#b0b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M155.9,48.76a.33.33,0,0,1,.12-.3c.07-.06.19,0,.34,0a.95.95,0,0,1,.46.79.3.3,0,0,1-.12.28h-.34a.85.85,0,0,1-.34-.34.84.84,0,0,1-.12-.43Z",
    fill: "#b0b3c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M158.05,50a.33.33,0,0,1,.12-.3c.07-.06.19,0,.34,0a.8.8,0,0,1,.34.34.91.91,0,0,1,.12.44.32.32,0,0,1-.12.29.688.688,0,0,1-.68-.4.84.84,0,0,1-.12-.37Z",
    fill: "#b0b3c1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M374.19,175.76l-1.6-2.75a2.57,2.57,0,0,0,.72-2,7.42,7.42,0,0,0-3.35-5.81c-1.86-1.07-3.36-.2-3.36,1.94A7.4,7.4,0,0,0,370,173a2.61,2.61,0,0,0,1.94.4l1.61,2.79c.19.32.49.5.68.39S374.37,176.09,374.19,175.76Zm-2.37-3.64a.28.28,0,0,0-.18,0,.27.27,0,0,0-.1.13A1.91,1.91,0,0,1,370,172a5.56,5.56,0,0,1-2.52-4.36c0-1.61,1.13-2.26,2.52-1.45a5.55,5.55,0,0,1,2.51,4.36,1.83,1.83,0,0,1-.69,1.57Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M338.43,219.64c-16.2-27.3-43.47-41-60.91-30.69l-15.16,8.71,5.81,9.67a22.311,22.311,0,0,1,3.3-4.09c14.74-4.78,35,6.63,47.5,27.64s12.76,44.29,1.51,54.94a21.591,21.591,0,0,1-4.55.91l5.67,9.42,14.57-8.35C353.61,277.45,354.62,246.93,338.43,219.64Z",
    fill: "#d6d8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M323.85,228c-16.2-27.3-43.47-41-60.91-30.69s-18.45,40.87-2.25,68.17,43.47,41,60.91,30.68S340.05,255.28,323.85,228Zm-3.37,57.83c-14.75,4.78-35-6.63-47.5-27.65s-12.76-44.28-1.51-54.93c14.74-4.78,35,6.63,47.5,27.64s12.76,44.28,1.51,54.93Z",
    fill: "#b1b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M273,258.17c-12.47-21-12.76-44.28-1.51-54.93,6.43-2.09,13.92-1.09,21.35,2.44-9.12-4.34-18.31-4.91-25.54-.62-14.85,8.81-15.79,34.67-2.1,57.74s36.84,34.64,51.69,25.83a20.2,20.2,0,0,0,3.61-2.81C305.73,290.6,285.45,279.19,273,258.17Z",
    fill: "#a1a5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M319,230.88c-12.47-21-32.76-32.42-47.5-27.64-11.25,10.65-11,33.92,1.51,54.93s32.75,32.43,47.5,27.65C331.73,275.17,331.44,251.9,319,230.88Z",
    fill: "#3e7eff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M339.29,264.71l32.69,18.85v8.42l-32.69-18.85Z",
    fill: "#b1b4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M346.58,260.5l32.69,18.85-7.29,4.21-32.69-18.85Z",
    fill: "#d6d8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M365.05,278.8c3.09-5.22,8.3-7.84,11.63-5.86l59.38,34.52-11.31,18.8-59.27-34.45C362.15,289.83,362,284,365.05,278.8Z",
    fill: "#65be7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M436.38,320.4c-3.1,5.21-8.3,7.84-11.63,5.86s-3.53-7.8-.43-13,8.3-7.84,11.63-5.86S439.47,315.19,436.38,320.4Z",
    fill: "#8c50ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M436.38,320.4c-3.1,5.21-8.3,7.84-11.63,5.86s-3.53-7.8-.43-13,8.3-7.84,11.63-5.86S439.47,315.19,436.38,320.4Z",
    fill: "#b7f498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M367.22,427.72,126.3,284c-1.16-.66-1-1.83.32-2.6h0a5,5,0,0,1,4.5-.18L372,424.94c1.16.67,1,1.83-.32,2.6h0a5,5,0,0,1-4.46.18Z",
    fill: "#d6d8e5",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M37.5,500,0,478.55l56.13-32.13,37.5,21.45Z",
    fill: "#d6d8e5",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M38.28,456.75,7.22,438.81l31.06-17.93,31.06,17.93Z",
    fill: "#d6d8e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M38.28,492.61,7.22,474.68V438.81l31.06,17.94Z",
    fill: "#b1b6c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M69.34,474.68,38.28,492.61V456.75l31.06-17.94Z",
    fill: "#c4c7d6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Men_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M80,463.39a10.57,10.57,0,0,0,8-1c1.93.06,12.39-4.42,13.81-.66,1.25,3.3-3.28,6.35-5.7,6.93-5.29,1.28-9.2,3.92-11.32,4.36-1.58.34-3.63.56-4.89-.69C78.41,470.87,78.54,465.36,80,463.39Z",
    fill: "#38226d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M84.81,472.14c2.12-.45,6-3.08,11.32-4.36,2-.49,5.52-2.71,5.87-5.36.47,3-3.62,5.73-5.87,6.27-5.29,1.28-9.2,3.92-11.32,4.36-1.58.34-3.63.56-4.89-.69a3,3,0,0,1-.69-1.26,6.33,6.33,0,0,0,5.58,1.04Z",
    fill: "#b7f498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M61.16,453.35a10.63,10.63,0,0,0,8-1c1.93.06,12.38-4.42,13.81-.66,1.24,3.3-3.29,6.34-5.71,6.93C72,459.93,68.07,462.57,66,463c-1.58.34-3.63.55-4.89-.69C59.55,460.83,59.68,455.31,61.16,453.35Z",
    fill: "#38226d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M66,462.1c2.12-.45,6-3.08,11.31-4.36,2-.49,5.53-2.71,5.88-5.36.47,3-3.62,5.72-5.88,6.27C72,459.93,68.07,462.57,66,463c-1.58.34-3.63.55-4.89-.69a3.14,3.14,0,0,1-.69-1.26A6.33,6.33,0,0,0,66,462.1Z",
    fill: "#b7f498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M31.79,440.33c8.16,3.58,15.85,4.15,22.14.77l6.5-3.75c.39,8.39.76,16.45.76,16.45s5,3.77,8.86.41c0,0,.81-11.78,1.63-23.36l6.82-3.93a8.409,8.409,0,0,0-.26,1.89c.05,2.2,1.58,34.91,1.58,34.91s5,3,8.9-.38c0,0,2.61-37.9,3.21-43.95.68-6.81-6.88-10.17-11.67-8.42-1.11.4-3.85,1.42-7.31,2.71.15-1.89.27-3.37.36-4.21.67-6.81-6.89-10.16-11.67-8.42-4.36,1.59-33.79,12.63-33.79,12.63a75,75,0,0,0,1,8.43l-11.63-1C16.56,432.06,23.64,436.74,31.79,440.33Zm20.3-18.84L59.87,417a10.429,10.429,0,0,0-.25,1.67Z",
    fill: "#65be7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M10.88,388s1,14.46,2.86,16.54S22.05,408,22.05,408L27,416.14s-4.51-25.86-5.49-26.48S10.88,388,10.88,388Z",
    fill: "#ffcea9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M20.39,371.9a5.39,5.39,0,0,0-6.88,2.1c-1.82,3-3.71,13.34-3.88,15.11,0,0,2.55,3.52,6.38,2.93Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M22.13,372.08c2.5.12,4.36.76,4.67,0a33.411,33.411,0,0,0,.57-3.91c-.29-.73-.54-1.51-.54-1.51-3.14-1.93-4.13-5.32-4.54-9.27-.7-6.75,2.94-12.66,9.7-13.37,6.34-.66,11,3.8,12.26,9.93.67,3,2,8.74.2,13.71-1,2.78-2.31,5-3.61,5.42a33.277,33.277,0,0,1-3.76-.33h0s-.34,1.88-.57,3.08-.14,1.84,2.25,3.32-3.62,4.51-7.55,4.21-8.36-2.67-9.57-5.21C20.29,375.34,20.41,372,22.13,372.08Z",
    fill: "#ffcea9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_",
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_2",
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_3",
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_3",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M85.45,416.32h0a2,2,0,0,1-1,1.76l-19.06,11a2,2,0,0,1-2,0L36.64,413.66a2,2,0,0,1-1-1.76v-.15Z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_4",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M84.44,418.08l-19.06,11a2,2,0,0,1-1,.27v-13H85.45A2,2,0,0,1,84.44,418.08Z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_4",
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M65.08,428.08a1.46,1.46,0,0,1-1.43,0l-27.76-16c-.35-.21-.35-.54,0-.74L56.34,399.5l29.11,16.82Z",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_5",
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M47.3,416.32l.14.08,8.89,5.13,4.89-2.82.13-.08-9.03-5.21Z",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_7",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M47.44,416.4l8.89,5.13,4.89-2.82-8.9-5.13Z",
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M77.9,417.15l1.29.74a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.13-.17,0-.23l-1.28-.74a.46.46,0,0,0-.41,0l-1.23.71C77.81,417,77.8,417.09,77.9,417.15Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M76.09,416.1l1.28.74a.46.46,0,0,0,.41,0l1.22-.71c.13-.07.14-.17,0-.23l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.7C76,415.93,76,416,76.09,416.1Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M74.27,415.05l1.29.74a.44.44,0,0,0,.4,0l1.23-.7c.12-.07.13-.18,0-.24l-1.29-.74a.44.44,0,0,0-.4,0l-1.23.7C74.18,414.88,74.17,415,74.27,415.05Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M72.46,414l1.28.74a.46.46,0,0,0,.41,0l1.22-.7c.12-.07.14-.18,0-.24l-1.25-.8a.46.46,0,0,0-.41,0l-1.22.7C72.36,413.83,72.35,413.94,72.46,414Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M70.64,413l1.28.74a.46.46,0,0,0,.41,0l1.23-.71c.12-.07.13-.18,0-.24L72.3,412a.46.46,0,0,0-.41,0l-1.22.71A.166.166,0,0,0,70.64,413Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M68.82,411.9l1.29.74a.44.44,0,0,0,.4,0l1.23-.71c.12-.07.13-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.23.71C68.73,411.74,68.72,411.84,68.82,411.9Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M67,410.85l1.28.75a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.14-.17,0-.23l-1.28-.75a.46.46,0,0,0-.41,0l-1.22.71C66.92,410.69,66.9,410.79,67,410.85Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M65.19,409.81l1.28.74a.46.46,0,0,0,.41,0l1.23-.71c.12-.07.13-.17,0-.23l-1.29-.74a.46.46,0,0,0-.41,0l-1.22.71A.128.128,0,0,0,65.19,409.81Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M63.37,408.76l1.29.74a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.13-.17,0-.23L65,407.8a.46.46,0,0,0-.41,0l-1.23.71C63.28,408.59,63.27,408.7,63.37,408.76Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M61.56,407.71l1.28.74a.46.46,0,0,0,.41,0l1.22-.7c.12-.07.14-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.7C61.47,407.54,61.45,407.65,61.56,407.71Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M59.74,406.66l1.28.74a.46.46,0,0,0,.41,0l1.23-.7c.12-.07.13-.18,0-.24l-1.29-.74a.44.44,0,0,0-.4,0l-1.23.7A.137.137,0,0,0,59.74,406.66Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M57.93,405.61l1.28.74a.49.49,0,0,0,.41,0l1.22-.71c.12-.07.14-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.23.71C57.83,405.45,57.82,405.55,57.93,405.61Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M56.11,404.56l1.28.74a.46.46,0,0,0,.41,0l1.23-.71c.12-.07.13-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.71C56,404.4,56,404.5,56.11,404.56Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M53.42,403l2.16,1.24a.41.41,0,0,0,.4,0l1.23-.71c.12-.07.13-.17,0-.23l-2.16-1.25a.46.46,0,0,0-.41,0l-1.22.7C53.33,402.84,53.31,403,53.42,403Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M73.45,416.61l1.28.74a.46.46,0,0,0,.41,0l1.23-.71c.12-.07.13-.17,0-.23l-1.29-.74a.46.46,0,0,0-.41,0l-1.22.71A.128.128,0,0,0,73.45,416.61Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M71.63,415.56l1.28.74a.46.46,0,0,0,.41,0l1.23-.71c.12-.07.13-.17,0-.23l-1.29-.74a.46.46,0,0,0-.41,0l-1.22.71A.128.128,0,0,0,71.63,415.56Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M69.81,414.51l1.28.74a.46.46,0,0,0,.41,0l1.23-.71c.12-.07.13-.17,0-.23l-1.29-.74a.46.46,0,0,0-.41,0l-1.22.71A.128.128,0,0,0,69.81,414.51Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M68,413.46l1.28.74a.46.46,0,0,0,.41,0l1.23-.71c.12-.07.13-.17,0-.23l-1.29-.74a.44.44,0,0,0-.4,0l-1.23.71A.123.123,0,0,0,68,413.46Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M66.19,412.41l1.28.74a.43.43,0,0,0,.41,0l1.22-.71c.12-.07.14-.17,0-.23l-1.28-.75a.46.46,0,0,0-.41,0l-1.22.71C66.1,412.25,66.08,412.35,66.19,412.41Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M64.37,411.36l1.28.74a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.14-.17,0-.24L66,410.4a.46.46,0,0,0-.41,0l-1.22.71C64.28,411.2,64.26,411.3,64.37,411.36Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M62.55,410.31l1.28.74a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.14-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.71C62.46,410.15,62.44,410.25,62.55,410.31Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M60.73,409.26,62,410a.46.46,0,0,0,.41,0l1.22-.71c.13-.07.14-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.71C60.64,409.1,60.62,409.2,60.73,409.26Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M58.91,408.21l1.28.74a.46.46,0,0,0,.41,0l1.23-.71c.12-.07.13-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.71C58.82,408.05,58.8,408.15,58.91,408.21Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M57.09,407.16l1.28.74a.46.46,0,0,0,.41,0l1.23-.71c.12-.07.13-.18,0-.24l-1.29-.74a.46.46,0,0,0-.41,0l-1.22.71C57,407,57,407.1,57.09,407.16Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M55.27,406.11l1.28.74a.46.46,0,0,0,.41,0l1.23-.7c.12-.07.13-.18,0-.24l-1.29-.74a.46.46,0,0,0-.41,0l-1.22.71C55.18,406,55.17,406.05,55.27,406.11Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M53.45,405.06l1.28.74a.46.46,0,0,0,.41,0l1.23-.7c.12-.07.13-.18,0-.24l-1.29-.74a.46.46,0,0,0-.41,0l-1.22.7A.137.137,0,0,0,53.45,405.06Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M75.27,417.66l2.16,1.24a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.13-.18,0-.24l-2.16-1.24a.49.49,0,0,0-.41,0l-1.22.71C75.18,417.49,75.16,417.6,75.27,417.66Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M53.3,403.06l1.28.74c.11.06.11.16,0,.22l-1.29.75a.42.42,0,0,1-.38,0l-.1-.06a.38.38,0,0,0-.36,0l-1.36.79a.42.42,0,0,1-.38,0l-.82-.47a.12.12,0,0,1,0-.22l1.28-.74.27-.15.19-.11.19-.11,1.1-.64a.42.42,0,0,1,.38,0Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M70.86,421.21l1.28.74a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.14-.17,0-.23l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.7A.13.13,0,0,0,70.86,421.21Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M69,420.16l1.29.74a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.13-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.23.71C69,420,68.94,420.1,69,420.16Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M67.23,419.12l1.29.74a.44.44,0,0,0,.4,0l1.23-.71c.12-.07.13-.17,0-.23l-1.28-.74a.46.46,0,0,0-.41,0l-1.23.71C67.14,419,67.13,419.06,67.23,419.12Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M51.81,410.21l1.28.74a.46.46,0,0,0,.41,0l1.23-.71c.12-.07.13-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.71C51.72,410.05,51.71,410.15,51.81,410.21Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M50,409.17l1.28.74a.46.46,0,0,0,.41,0l1.22-.71c.13-.07.14-.17,0-.23l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.71C49.91,409,49.89,409.11,50,409.17Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M48.19,408.12l1.28.74a.46.46,0,0,0,.41,0l1.22-.7c.12-.07.14-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.7C48.1,408,48.08,408.06,48.19,408.12Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M46.38,407.07l1.28.75a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.14-.17,0-.23L48,406.11a.46.46,0,0,0-.41,0l-1.22.71C46.28,406.91,46.27,407,46.38,407.07Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M65,417.8l1.75,1a.44.44,0,0,0,.4,0l1.23-.7c.12-.07.13-.18,0-.24l-1.75-1a.46.46,0,0,0-.41,0l-1.22.71C64.86,417.64,64.85,417.74,65,417.8Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M53.62,411.26l1.75,1a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.14-.17,0-.23l-1.75-1a.46.46,0,0,0-.41,0l-1.22.71A.128.128,0,0,0,53.62,411.26Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M55.9,412.57l8.53,4.93a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.13-.17,0-.23l-8.53-4.93a.46.46,0,0,0-.41,0l-1.22.71C55.81,412.41,55.79,412.51,55.9,412.57Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M71.2,417.34l1.28.74a.46.46,0,0,0,.41,0l1.22-.7c.12-.07.14-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.23.7A.134.134,0,0,0,71.2,417.34Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M69.38,416.29l1.28.74a.46.46,0,0,0,.41,0l1.23-.7c.12-.07.13-.18,0-.24l-1.3-.76a.46.46,0,0,0-.41,0l-1.22.71C69.29,416.12,69.28,416.23,69.38,416.29Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M67.57,415.24l1.28.74a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.14-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0L67.6,415C67.48,415.08,67.46,415.18,67.57,415.24Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M65.75,414.2l1.29.74a.44.44,0,0,0,.4,0l1.23-.71c.12-.07.13-.17,0-.23l-1.29-.74a.44.44,0,0,0-.4,0l-1.23.71A.128.128,0,0,0,65.75,414.2Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M63.94,413.15l1.28.74a.46.46,0,0,0,.41,0l1.22-.7c.13-.07.14-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.7C63.85,413,63.83,413.09,63.94,413.15Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M62.12,412.1l1.29.74a.46.46,0,0,0,.41,0l1.22-.7c.12-.07.13-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.23.71C62,411.93,62,412,62.12,412.1Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M60.31,411.05l1.28.74a.46.46,0,0,0,.41,0l1.23-.71c.12-.07.13-.17,0-.24L62,410.09a.46.46,0,0,0-.41,0l-1.22.71C60.22,410.89,60.21,411,60.31,411.05Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M58.5,410l1.28.74a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.14-.17,0-.23l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.71C58.4,409.84,58.39,410,58.5,410Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M56.68,409l1.28.74a.46.46,0,0,0,.41,0l1.23-.7c.12-.07.13-.18,0-.24l-1.26-.8a.44.44,0,0,0-.4,0l-1.23.7A.179.179,0,0,0,56.68,409Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M54.87,407.91l1.28.74a.46.46,0,0,0,.41,0l1.22-.7c.12-.07.14-.18,0-.24L56.53,407a.46.46,0,0,0-.41,0l-1.22.71C54.78,407.75,54.76,407.85,54.87,407.91Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M53.05,406.86l1.29.74a.44.44,0,0,0,.4,0l1.23-.71c.12-.07.13-.17,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.23.71A.21.21,0,0,0,53.05,406.86Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M51.24,405.82l1.28.74a.46.46,0,0,0,.41,0l1.22-.71c.13-.07.14-.17,0-.23l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.71C51.15,405.65,51.13,405.76,51.24,405.82Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M73,418.39l2.65,1.53a.46.46,0,0,0,.41,0l1.23-.71c.12-.07.13-.17,0-.23l-2.66-1.53a.46.46,0,0,0-.41,0l-1.22.71A.136.136,0,0,0,73,418.39Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M70.34,418.87l1.28.75a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.14-.17,0-.23L72,417.92a.43.43,0,0,0-.41,0l-1.22.71C70.24,418.71,70.23,418.81,70.34,418.87Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M68.52,417.83l1.28.74a.46.46,0,0,0,.41,0l1.23-.71c.12-.07.13-.17,0-.23l-1.29-.74a.44.44,0,0,0-.4,0l-1.23.71A.128.128,0,0,0,68.52,417.83Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M66.71,416.78l1.28.74a.46.46,0,0,0,.41,0l1.22-.7c.12-.07.14-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.7C66.62,416.61,66.6,416.72,66.71,416.78Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M64.89,415.73l1.29.74a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.13-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.23.71C64.8,415.57,64.79,415.67,64.89,415.73Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M63.08,414.69l1.28.74a.46.46,0,0,0,.41,0L66,414.7c.12-.07.13-.17,0-.23l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.71A.155.155,0,0,0,63.08,414.69Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M61.27,413.64l1.28.74a.46.46,0,0,0,.41,0l1.22-.7c.12-.07.14-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.7C61.17,413.47,61.16,413.58,61.27,413.64Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M59.45,412.59l1.28.74a.46.46,0,0,0,.41,0l1.23-.7c.12-.07.13-.18,0-.24l-1.29-.74a.44.44,0,0,0-.4,0l-1.23.71A.128.128,0,0,0,59.45,412.59Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M57.64,411.54l1.28.74a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.14-.17,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.71C57.55,411.38,57.53,411.48,57.64,411.54Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M55.82,410.5l1.29.74a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.13-.17,0-.23l-1.28-.74a.46.46,0,0,0-.41,0l-1.23.71A.128.128,0,0,0,55.82,410.5Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M54,409.45l1.28.74a.46.46,0,0,0,.41,0l1.23-.7c.12-.07.13-.18,0-.24l-1.29-.74a.46.46,0,0,0-.41,0l-1.22.7A.145.145,0,0,0,54,409.45Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M52.2,408.4l1.28.74a.46.46,0,0,0,.41,0l1.22-.71c.12-.07.14-.18,0-.24l-1.28-.74a.46.46,0,0,0-.41,0l-1.22.71C52.1,408.24,52.09,408.34,52.2,408.4Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M48.14,406.06l3.53,2a.44.44,0,0,0,.4,0l1.23-.71c.12-.07.13-.17,0-.23l-3.53-2a.46.46,0,0,0-.41,0l-1.22.7C48.05,405.89,48,406,48.14,406.06Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M72.15,419.92l1.75,1a.49.49,0,0,0,.41,0l1.22-.71c.12-.07.14-.18,0-.24l-1.75-1a.46.46,0,0,0-.41,0l-1.22.71C72.06,419.76,72,419.86,72.15,419.92Z",
    fill: "#3a2c6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_6",
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_7",
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430_8",
    "data-name": "<\\u0413\\u0440\\u0443\\u043F\\u043F\\u0430>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M85.45,416.32h0L56.34,399.5V376.61l.22-.52.24-.12h0a2,2,0,0,1,2,0l26.64,15.39a2,2,0,0,1,1,1.74v21.48C86.27,415.69,86.07,416,85.45,416.32Z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_9",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M82.78,394.13,56.34,377.37v-.76l.22-.52.24-.12a2,2,0,0,1,2,0l26.64,15.39a2.08,2.08,0,0,1,.77.79Z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_10",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M57,376.09l28,16.14a1,1,0,0,1,.49.85v23.24L56.34,399.5v-23a.45.45,0,0,1,.66-.41Z",
    fill: "#dceeff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M57,376.09l28,16.14a1,1,0,0,1,.49.85v23.24L56.34,399.5v-23a.45.45,0,0,1,.66-.41Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M85.45,416.31v-.82L56.34,398.67v.83Z",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_13",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M57.09,398.28V377.29l.36.21v20.61Z",
    fill: "#1e3779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_14",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M57.45,377.5v20.61L84.52,413.7V393.13Z",
    fill: "#3a2c6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_15",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M57.09,398.28l27.43,15.83v-.41L57.45,398.11Z",
    fill: "#031f60"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_16",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M25.74,372.45c-.69,1.72,1.07,3.84,5.76,5.31s5.12-.42,5.12-.42a94.608,94.608,0,0,1,9.13,4.7c2.81,2,4.06,7.67,4.44,17.29.44,11.14.48,27.66.11,30.51,0,0-5.27,5.24-12,4.69S20.22,428,17.47,423.41c.07-9.76,1.22-11.35-.36-17-3.62-12.87-5.53-18.15-3.77-26.7,1.45-7.05,3.48-7.93,6.27-7.86a58,58,0,0,1,6.13.6Z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_17",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M61.27,411.27c-5.52,1.39-6.82-2.09-7.55-5C52,399.3,51,393,49.7,389c-1.54-4.68-3.16-5.43-5.44-6.34-2.67-1.07-5,1.19-4.07,7.14,1.05,7.05,2.43,12,5.06,20.33.69,2.18,2.23,6.05,4.54,7.92,2.86,2.3,7.15,2.2,13.66.59,2.77-.69,5.81-2.35,11-4.8,1.41-.65,2.51-1.09,5.21-2.35a18.5,18.5,0,0,0,6.93-5.41c1.42-2.05,1.61-3,1.32-3.48s-1-.46-1.76.4a15.2,15.2,0,0,1-4,3.69s1.74-1.81,2.69-3A14.629,14.629,0,0,0,87,400.31c.5-1.19-.53-2.82-1.31-2s-1.16,1.73-2.59,3.44a14.721,14.721,0,0,1-2.56,2.44,27.441,27.441,0,0,0,2.36-3.79,6.25,6.25,0,0,0,.86-3.44c0-.62-.92-1.36-1.75-.18s-1.23,2.73-3,4.54c-1.26,1.31-2.33,2.06-2.37,1.7s.77-1.09,1.22-2.61,0-3.14-.85-3.32-.68-.13-1.35,1.3A51.08,51.08,0,0,0,73.17,403a9.23,9.23,0,0,1-2.27,3.91C69.54,408.35,66.53,410,61.27,411.27Z",
    fill: "#ffcea9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_18",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    d: "M42.22,381.73c3.69-.55,6.3,1.11,7.93,6.71s2.77,10.19,2.77,10.19a10.06,10.06,0,0,1-6.19,4.11c-4.41,1.06-6-1.05-6-1.05s-1.23-5.86-2-9.85S37.65,382.4,42.22,381.73Z",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M44,353.08s5.83-8.87-6.81-10.67c-9.12-1.31-15,4.55-15.65,10.91-.65,6.07,3.09,12.38,5.79,14.88,1.32.47,4.15.74,7.88-.95a44,44,0,0,0,.17-5S31,352.92,44,353.08Z",
    fill: "#3a2c6d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M69.34,465.31V438.67L48.19,451.02l8.15,16.85Z",
    fill: "#c4c7d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M55.48,440.21l8.12-4.71,5.74,3.31-8.42,4.78Z",
    fill: "#d6d8e5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c52e903b68bc11f43d3ffcc851bb3142.svg";
export { ForwardRef as ReactComponent };